import * as React from 'react';
import { Location } from 'history';

import { IComment } from '../../types/posts';
import { ICommentState } from '../../types/posts';
import { IUser } from '../../types/user';
import { CommentForm } from './comment_form';
import { Answer } from './answer';

import s from './comments.css';

interface IProps {
  location: Location;
  user: IUser;
  likesShown: boolean;
  canComment: boolean;
  commentsState: ICommentState;
  replyTo: string;
  parentID: number | null;
  onCommentSubmit(comment: string, userId: number, fullName: string, email: string, parentID: number | null, subs: boolean): void;
  answers: IComment[];
  onCommentEdit(id: number, comment: string, email: string): void;
  onCommentDelete(id: number, email: string): void;
  onCommentHide(id: number, email: string): void;
  cardType: string;
}

export const Answers: React.FC<IProps> = ({
  location,
  user,
  likesShown,
  canComment,
  commentsState,
  replyTo,
  parentID,
  onCommentSubmit,
  answers,
  onCommentEdit,
  onCommentDelete,
  onCommentHide,
  cardType,
}) => {
  const [addingComment, setAddingComment] = React.useState(false);
  const [replyToState, setReplyToState] = React.useState('');
  const [editingComment, setEditingComment] = React.useState(false);
  const [selectedAnswer, setSelectedAnswer] = React.useState<IComment | undefined>(undefined);
  const [savedFields, setSavedFields] = React.useState<{
    comment: string;
    name: string;
    email: string;
    subscribe: boolean;
  } | undefined>(undefined);

  const prevLoadedRef = React.useRef(commentsState.loaded);

  React.useEffect(() => {
    const wasLoaded = prevLoadedRef.current;
    prevLoadedRef.current = commentsState.loaded;

    if (!commentsState.error && commentsState.loaded && commentsState.loaded !== wasLoaded) {
      setAddingComment(false);
      setReplyToState('');
      setEditingComment(false);
    }
  }, [commentsState.error, commentsState.loaded]);

  const handleAddComment = () => {
    if (user.userId === -1) {
      window.waitForLoginPopup();
      return;
    }
    setAddingComment(true);
    setReplyToState(replyTo || '');
    setEditingComment(false);
    setSelectedAnswer(undefined);
  };

  const saveFields = (comment: string, name: string, email: string, subscribe: boolean) => {
    setSavedFields({ comment, name, email, subscribe });
  };

  return (
    <div className={s['comments__list-answer']}>
      {answers.map((answer: IComment) =>
        <Answer
          location={location}
          likesShown={likesShown}
          canComment={canComment}
          key={`answer-${answer.id}`}
          answer={answer}
          onCommentDelete={onCommentDelete}
          onCommentHide={onCommentHide}
          user={user}
          onCommentSubmit={onCommentSubmit}
          parentID={parentID}
          commentsState={commentsState}
          onCommentEdit={onCommentEdit}
          cardType={cardType}
        />,
      )}
      {canComment && (addingComment || editingComment) ?
        <CommentForm
          onOpen={() => {}}
          onClose={() => {
            setAddingComment(false);
            setReplyToState('');
            setEditingComment(false);
          }}
          onCommentSubmit={(
            comment: string,
            userId: number,
            fullName: string,
            email: string,
            pid: number | null,
            subs: boolean,
          ) => onCommentSubmit(comment, userId, fullName, email, pid, subs)}
          commentsState={commentsState}
          replyTo={replyToState}
          parentID={parentID}
          comment={selectedAnswer}
          editingComment={editingComment}
          onCommentEdit={onCommentEdit}
          isOpened={true}
          user={user}
          saveFields={saveFields}
          savedFields={savedFields}
          cardType={cardType}
        />
        :
        canComment &&
          <div className={s['comments__list-answer_add']}>
            <button
              className={s['comments__list-answer_add-btn']}
              onClick={handleAddComment}
            >
              Добавить комментарий
            </button>
          </div>
      }
    </div>
  );
};
